<!--
    @file:登录页面的拖拽滑动组件
    @props:{boolean} initialDrag 值的改变会触发drag组件还原成未拖拽的模式
-->

<template>
    <div id="drag" v-bind:class="{ active: isActive }">
        <div class="drag_bg" v-bind:style="{ width: move + 'px' }"></div>
        <div class="drag_text" onselectstart="return false;" unselectable="on">{{ message }}</div>
        <div
            class="handler handler_bg"
            v-bind:style="{ transform: 'translateX(' + move + 'px)' }"
            v-on:mousedown="dragMouseDown($event)" v-on:mouseleave="dragMouseUp($event)">
        </div>
    </div>
</template>

<script>
export default {
    name: 'drag',
    data () {
        return {
            drag: false,
            move: 0,
            x: 0,
            message: '请按住滑块,拖动到最右',
            isActive: false,
            maxMove: 216
        };
    },
    props: ['initialDrag'],
    methods: {
        dragMouseDown (e) {
            e.preventDefault();
            if (!this.isActive) {
                this.drag = true;
                this.x = e.pageX - this.move;
                window.addEventListener('mousemove', this.dragMouseMove);
                window.addEventListener('mouseup', this.dragMouseUp);
            }
        },
        dragMouseMove (e) {
            if (this.drag === true && !this.isActive) {
                var move = e.pageX - this.x;
                if (move > 0 && move <= this.maxMove) {
                    this.move = move + 2;
                } else if (move > this.maxMove) {
                    this.move = this.maxMove;
                    this.message = '验证通过';
                    this.isActive = true;
                    this.$emit('drag');
                }
            }
        },
        dragMouseUp (e) {
            if (this.drag === true && !this.isActive) {
                this.drag = false;
                var move = e.pageX - this.x;
                if (move < this.maxMove) {
                    this.message = '验证失败,请重新拖动';
                    this.move = 0;
                }
            }
            window.removeEventListener('mousemove', this.dragMouseMove);
            window.removeEventListener('mouseup', this.dragMouseUp);
        }
    },
    watch: {
        initialDrag (val) {
            this.move = 0;
            this.message = '按住滑块,拖动到最右';
            this.isActive = false;
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#drag {
    position: relative;
    background-color: #e5e5e5;
    width: 243px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    margin: 22px 0 22px 0;
}
.drag_bg {
    background-color: #94c0ff;
    height: 26px;
    width: 0px;
}
.drag_text {
    font-size: 14px;
    color: #999;
    position: absolute;
    top: 0px;
    width: 243px;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select: none;
    -ms-user-select: none;
}
.handler {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 24px;
    height: 24px;
    border: 1px solid #e5e5e5;
    cursor: move;
}
.handler:after{
    content: "";
    position: absolute;
    width: 70px;
    height: 70px;
    top: -25px;
    left: 0;
}
.handler_bg {
    background: #fff url(../../assets/img/login-drag.png) no-repeat center;
}
.active>.handler_bg{
    background: #fff url(../../assets/img/login-drag-ok.png) no-repeat center;
}
.active>.handler {
    border:1px solid #94c0ff;
}
.active .drag_text{
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// drag.vue?36431da6